export const routes = {
  brandUsersAccess: {
    access: '/brand-users-access',
    accessList: '/brand-users-access/brand',
    changePermissions: '/brand-users-access/permissions',
  },
  brandUsers: {
    brands: '/brand-users/brands',
    pendingSignup: 'brand-users/pending-signup',
    validate: '/brand-users/validate',
    validateSignupToken: '/brand-users/validate-signup-token',
  },
};
